module.exports = __webpack_public_path__ + "static/media/30.92cbc642.svg";